import React from 'react';
import { BsFileText } from '@react-icons/all-files/bs/BsFileText';

import { decorateComponent } from '../../documentComponents';
import { Page } from './Page';

export default decorateComponent(Page, 'block', {
  id: 'page',
  label: '페이지',
  allowedParent: [],
  disabledMove: true,
  disabledClone: true,
  disabledDelete: true,
  renderIcon: () => <BsFileText />,
});
